import { z } from 'zod';

export const ShadowSettingKeySchema = z.enum(['NONE', 'HARD', 'MEDIUM', 'SOFT']).optional();
export type ShadowSettingKey = z.infer<typeof ShadowSettingKeySchema>;
